import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { isCanadianIdentityCountry } from '@shared/constants/identity-formats';

import { luhnValidator } from './luhn';
import { siblingCountryCode } from './sibling-country';

/**
 * Country-aware national-id validation.
 *
 * The regex on the field covers length and the leading-digit rules for both countries; this adds the Canadian
 * Luhn check digit, which a regex cannot express. US SSNs have no checksum, so US is a no-op here.
 *
 * The country is resolved per validation run rather than captured once, because the user can change the country
 * select after the field has rendered.
 */
export const socialIdValidatorFor = (countryCodeKey: string) => (control: AbstractControl, field?: FormlyFieldConfig) =>
  isCanadianIdentityCountry(siblingCountryCode(control, field, countryCodeKey)) ? luhnValidator(control) : null;
